import { render, staticRenderFns } from "./Render.vue?vue&type=template&id=b2f77d5c&scoped=true&"
import script from "./Render.vue?vue&type=script&lang=js&"
export * from "./Render.vue?vue&type=script&lang=js&"
import style0 from "./Render.css?vue&type=style&index=0&id=b2f77d5c&scoped=true&lang=css&"
import style1 from "../CSS/Print.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f77d5c",
  null
  
)

export default component.exports